import BUSContext from 'contexts/JWTContext';
import { useContext } from 'react';

// ==============================|| AUTH HOOK ||============================== //

const useAuth = () => {
  const context = useContext(BUSContext);

  if (!context) {
    throw new Error('useAuth must be used within a JWTProvider');
  }

  return {
    ...context,
    // Convenience getters
    user: context.user,
    isLoggedIn: context.isLoggedIn,
    token: context.token,
    isInitialized: context.isInitialized,

    // User info helpers
    fullName: context.user ? `${context.user.first_name} ${context.user.last_name}` : '',
    firstName: context.user?.first_name || '',
    lastName: context.user?.last_name || '',
    email: context.user?.email || '',
    phone: context.user?.phone || '',
    roleId: context.user?.role_id || '',
    userId: context.user?.id || null,

    // Role helpers
    isAdmin: context.user?.role_id === '1',
    isUser: context.user?.role_id !== '1',

    // Token helpers
    hasValidToken: context.token && context.user?.expires_at && new Date() < new Date(context.user.expires_at),

    // Actions
    login: context.login,
    logout: context.logout,
    register: context.register,
    changeEmail: context.changeEmail,
    changePassword: context.changePassword,
    forgotPassword: context.forgotPassword,
    resetPassword: context.resetPassword
  };
};

export default useAuth;
